import { render, staticRenderFns } from "./SideBarButtonPrimary.vue?vue&type=template&id=589bcd0d"
import script from "./SideBarButtonPrimary.vue?vue&type=script&lang=js"
export * from "./SideBarButtonPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports